import { render, staticRenderFns } from "./cModalGenerarFact.vue?vue&type=template&id=f1024f16"
import script from "./cModalGenerarFact.vue?vue&type=script&lang=js"
export * from "./cModalGenerarFact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports